import { useEffect, useRef, useState } from 'react'

import { BreakpointKey } from '@/modules/shared/types/BreakpointKey'

type BreakpointStates = Record<BreakpointKey, boolean>

export const defaultBreakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  twoXL: 1536,
  threeXL: 1860,
  fourXL: 2260,
  fiveXL: 2660,
}

export function useWindowSize() {
  const [width, setWidth] = useState(window.innerWidth)
  const frameRef = useRef<number | null>(null)

  useEffect(() => {
    const handleWindowResize = () => {
      if (frameRef.current !== null) return

      frameRef.current = window.requestAnimationFrame(() => {
        frameRef.current = null
        setWidth(window.innerWidth)
      })
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      if (frameRef.current !== null) {
        window.cancelAnimationFrame(frameRef.current)
      }
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  const breakpointStates: BreakpointStates = Object.entries(defaultBreakpoints).reduce((acc, [key, value]) => {
    acc[key as BreakpointKey] = width >= value
    return acc
  }, {} as BreakpointStates)

  const isLargeScreen = width >= defaultBreakpoints.lg

  return { isLargeScreen, width, ...breakpointStates }
}
